import { render, staticRenderFns } from "./ContratoCotacao.vue?vue&type=template&id=323aa0a2"
import script from "./ContratoCotacao.vue?vue&type=script&lang=js"
export * from "./ContratoCotacao.vue?vue&type=script&lang=js"
import style0 from "./ContratoCotacao.vue?vue&type=style&index=0&id=323aa0a2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports